import { ProductoDetalleDsKey, ProductoTiendaDsKey } from "../../business/entities/ProductoTiendaDsKey";
import { ProductoTiendaDsKeyModel } from "./ProductoTiendaDsKeyModel";

export class ProductoDetalleDsKeyModel implements ProductoDetalleDsKey {

    constructor(
        public codigoProducto: string,
        public codigoVersion: string,
        public codigoPresentacion: string,
        public urlInstalador: string,
        public producto?: string,
        public version?: string,
        public presentacion?: string,
        public idProdVerPres?: string,
        public shopCodProds?: ProductoTiendaDsKey[]
    ) { }

    serialize(): ProductoDetalleDsKey {
        return {
            codigoProducto: this.codigoProducto,
            codigoVersion: this.codigoVersion,
            codigoPresentacion: this.codigoPresentacion,
            urlInstalador: this.urlInstalador,
            producto: this.producto,
            version: this.version,
            presentacion: this.presentacion,
            idProdVerPres: this.idProdVerPres,
            shopCodProds: this.shopCodProds
        };
    }

    static deserialize(formatoBase: ProductoDetalleDsKey): ProductoDetalleDsKeyModel {
        return new ProductoDetalleDsKeyModel(
            formatoBase.codigoProducto,
            formatoBase.codigoVersion,
            formatoBase.codigoPresentacion,
            formatoBase.urlInstalador,
            formatoBase.producto,
            formatoBase.version,
            formatoBase.presentacion,
            formatoBase.idProdVerPres,
            formatoBase.shopCodProds?.map(item =>
                ProductoTiendaDsKeyModel.deserialize(item)
            )
        );
    }
}